import Vue from 'vue';
import { upperFirst } from './helpers';

// Glob import all Base*.vue or Base*.js components
const components = import.meta.glob('../components/base-components/Base*.{vue,js}');

Object.entries(components).forEach(([path, componentLoader]) => {
  const fileName = path.split('/').pop();
  const componentName = upperFirst(fileName.replace(/\.\w+$/, ''));

  // Register async component
  Vue.component(componentName, () => componentLoader());
});
